{ "closeAria": "閉じる", "historyAria": "お問い合わせ履歴", "supportTitle": "サポート" }
